import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_495: DocMigration = {
  maxSchemaVersion: "0.0.495",
  description: "Ensure inline image annotations have a width and height",
  apply(json: any): any {
    for (const id in json.annotation) {
      const annotation = json.annotation[id];
      if (annotation.type === "DETAIL" && annotation.detailType === "INLINE_IMAGE") {
        if (annotation.width === undefined) {
          annotation.width = 0;
        }
        if (annotation.height === undefined) {
          annotation.height = 0;
        }
        if (annotation.assetAspectRatio === undefined) {
          if (annotation.height === 0 || annotation.width === 0) {
            annotation.assetAspectRatio = 1;
          } else {
            annotation.assetAspectRatio = annotation.width / annotation.height;
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_495;
